class GraphicManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }
    run() {
        document.querySelectorAll('[data-graphic]').forEach((el) => this.init(el))
    }
    init(el) {
        let data = []
        const dataSrc = document.querySelector('meta[name="' + el.dataset.graphic + '"]')
        if (dataSrc) {
            data = JSON.parse(dataSrc.getAttribute('content'))
        }
        const mGraphicElement = new GraphicElement(this, el, data)
        mGraphicElement.run()
    }
}

class GraphicElement {
    constructor(parent, el, data) {
        this.el = el
        this.title = el.dataset.graphicTitle
        this.fieldY = el.dataset.graphicFieldY
        this.fieldYSufix = el.dataset.graphicFieldYSufix || ''
        this.fieldX = el.dataset.graphicFieldX
        this.data = data.map((item) => item[this.fieldY])
        this.dataLabel = data.map((item) => item[this.fieldX])
    }
    run() {
        this.chart = new Chart(this.el, {
            type: 'bar',
            data: {
                labels: this.dataLabel,
                datasets: [{
                    label: this.title,
                    data: this.data,
                    backgroundColor: [
                        'rgba(7, 109, 242, 1)',
                    ],
                    borderRadius: 5,
                }]
            },
            options: {
                maintainAspectRatio: false,
                layout: {
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const label = context.dataset.label || '';
                                const value = context.parsed.y;
                                return `${label}: ${value}*`;
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        grid: {
                            color: 'rgba(207, 232, 253, 1)',
                            borderColor: 'rgba(207, 232, 253, 1)',
                            borderWidth: 2,
                            borderDash: [8, 16],
                            circular: true
                        },
                        ticks: {
                            callback: (value, index, values) => {
                                return value + this.fieldYSufix;
                            }
                        }
                    },
                    x: {
                        grid: {
                            display: false,
                        }
                    }
                }
            }
        })
    }
}

export default GraphicManager